import { useSelector } from 'react-redux';
import SkeletonNewsBlock from '../../../universal_components/Skeletots/SkeletonNewsBlock';
import styles from './ProjectsList.module.scss';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const ProjectsList = () => {
  const projectsList = useSelector((state) => state.projects.projects);

  const filterYear = useSelector((state) => state.projects.filterYearProjects);

  const filteredProjects = filterYear
    ? projectsList.filter((proj) => new Date(proj.year).getFullYear() === filterYear)
    : projectsList;

  if (projectsList.length === 0) {
    return (
      <ul className={styles.list}>
        {Array.from({ length: 6 }).map((_, index) => (
          <SkeletonNewsBlock key={index} width={240} height={243} />
        ))}
      </ul>
    );
  }

  return (
    <ul className={classnames(isMobile ? [styles.list, styles.mobile] : [styles.list])}>
      {filteredProjects.map((item) => {
        return (
          <li className={styles.item} key={item.id}>
            <Link to={`/projects/${item.id}`}>
              <div className={styles.image}>
                <img src={item.cover} alt={item.name} />
              </div>

              <h3 className={styles.title}>{item.name}</h3>
            </Link>
          </li>
        );
      })}
    </ul>
  );
};

export default ProjectsList;
